<template>
	<div>
		<v-dialog :value="$wait.is('modal reservation')" scrollable persistent max-width="600px">
			<v-card>
				<v-card-title>{{ $t("title.new_reservation") }}</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-list>
						<v-layout row wrap>
							<v-flex xs12 md6>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>{{
										$t("label.outlet_name")
										}}</v-list-item-title>
										<v-list-item-subtitle>
											{{ reservation.outlet_name }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-flex>
							<v-flex xs12 md6>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>{{
										$t("Code")
										}}</v-list-item-title>
										<v-list-item-subtitle>
											{{ reservation.code }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-flex>
							<v-flex xs12 md6>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>{{
										$t("label.adults")
										}}</v-list-item-title>
										<v-list-item-subtitle>
											{{ reservation.adults }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-flex>
							<v-flex xs12 md6>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>{{
										$t("label.children")
										}}</v-list-item-title>
										<v-list-item-subtitle>
											{{ reservation.children }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-flex>
							<v-flex xs12 md6>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>{{
										$t("Date")
										}}</v-list-item-title>
										<v-list-item-subtitle>
											{{ reservation.date }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-flex>
							<v-flex xs12 md6>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>{{
										$t("Time")
										}}</v-list-item-title>
										<v-list-item-subtitle>
											{{ reservation.time }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-flex>
							<v-flex xs12>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>{{
										$t("Description")
										}}</v-list-item-title>
										<v-list-item-subtitle>
											{{ reservation.description }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-flex>
						</v-layout>
					</v-list>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions v-if="$route().current('tenant.*')">
					<v-spacer></v-spacer>
					<v-btn color="error" text @click="denied_reservation(reservation)">
						{{ $t("label.mark_as_declined") }}
					</v-btn>
					<v-btn color="success" @click="confirmed(reservation)">
						{{ $t("label.mark_as_accepted") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
				<v-card-actions v-else-if="$route().current('central.*')">
					<v-spacer></v-spacer>
					<v-btn text @click="$wait.end('modal reservation')">
						<v-icon left>mdi-close</v-icon>
						{{ $t("Close") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog :value="$wait.is('modal order')" scrollable persistent max-width="1200px">
			<v-card>
				<v-card-title>
					<v-layout row wrap class="py-2 px-2">
						<v-flex xs12 md2 class="mt-5">
							<v-img src="/images/image_placeholder.jpg" width="150" height="150"></v-img>
						</v-flex>
						<v-flex xs12 md10>
							<v-card flat>
								<v-card-title class="px-0">
									{{
									order.address
									? order.address.contact_person
									: "N/A"
									}}
									<v-spacer></v-spacer>
									<v-btn icon @click="closeItem()" text class="margin-right: 20px">
										<v-icon>mdi-close</v-icon>
									</v-btn>
									<v-btn color="error" @click="declined(order)" outlined>
										{{ $t("label.declined") }}
									</v-btn>
								</v-card-title>
								<v-card-subtitle class="py-0 px-0">
									{{
									order.address
									? order.address.phone_number
									: "N/A"
									}}
								</v-card-subtitle>
							</v-card>
							<v-card-text class="py-0 px-0">
								<v-simple-table class="simple_table" dense>
									<thead>
										<tr>
											<th>
												{{ $t("label.order_number") }}
											</th>
											<th>
												{{ $t("label.order_date") }} &
												{{ $t("Time") }}
											</th>
											<th>{{ $t("Type") }}</th>
											<th>{{ $t("Amount") }}</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>{{ order.code }}</td>
											<td>
												{{ order.date }} @
												{{ order.time }}
											</td>
											<td>
												<v-btn x-small color="primary">{{ order.type }}</v-btn>
											</td>
											<td>
												{{ order.total | currency
												}}<v-btn color="black" dark x-small class="ml-1 mb-1">{{
												order.payment_method_code
												}}</v-btn>
											</td>
										</tr>
									</tbody>
								</v-simple-table>
							</v-card-text>
						</v-flex>
					</v-layout>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-layout row wrap class="py-2 px-2">
						<v-flex xs12 md8>
							<div class="px-5">
								<v-list>
									<v-list-item>
										<v-list-item-content>
											<v-list-item-subtitle>
												{{ $t("label.delivery_address")
												}}<v-btn color="black" class="ml-5" dark x-small>{{
												order.address
												? order.address.name
												: "N/A"
												}}</v-btn>
											</v-list-item-subtitle>

											<v-list-item-title>{{
											order.address
											? order.address
											.house_number
											: "N/A"
											}},
												{{
												order.address
												? order.address.street
												: "N/A"
												}},
												{{
												order.address
												? order.address.address
												: "N/A"
												}}</v-list-item-title>
										</v-list-item-content>

										<v-list-item-action>
											<!-- 3.6 km -->
										</v-list-item-action>
									</v-list-item>
								</v-list>
							</div>
							<v-divider></v-divider>
							<div class="py-5 px-5">
								<v-simple-table class="simple_table" dense>
									<thead>
										<tr>
											<th>
												{{ $t("label.ordered_item") }}
											</th>
											<th>&nbsp;</th>
											<th>&nbsp;</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(line, index) in order.items" :key="index">
											<td>{{ line.product_name }}</td>
											<td>{{ line.quantity }} |</td>
											<td>{{ line.price | currency }}</td>
										</tr>
									</tbody>
								</v-simple-table>
							</div>
							<div class="px-5">
								<v-divider></v-divider>
								<v-list>
									<v-list-item>
										<v-list-item-content>
											<v-list-item-subtitle>{{
											$t(
											"label.additional_information_form_customer"
											)
											}}</v-list-item-subtitle>

											<v-list-item-title>
												{{ order.description }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</div>
						</v-flex>
						<v-divider vertical></v-divider>
						<v-flex xs12 md4 class="py-2 px-5">
							<div class="mt-5">
								<header>{{ $t("label.other_details") }}</header>
								<v-simple-table class="simple_table" dense>
									<thead>
										<tr>
											<th>
												{{ $t("label.delivery_date") }}:
											</th>
											<th>{{ order.date }}</th>
										</tr>
										<tr>
											<th>
												{{ $t("label.delivery_time") }}
											</th>
											<th>{{ order.time }}</th>
										</tr>
									</thead>
								</v-simple-table>
							</div>
							<v-divider></v-divider>
							<div class="mt-5">
								<header>
									{{ $t("label.transaction_details") }}
								</header>
								<v-simple-table class="simple_table" dense>
									<thead>
										<tr>
											<th>
												{{ $t("label.sub_total") }}:
											</th>
											<th>
												{{ order.subtotal | currency }}
											</th>
										</tr>
										<tr>
											<th>
												{{ $t("label.delivery_fee") }}:
											</th>
											<th>0</th>
										</tr>
										<tr>
											<th>
												{{ $t("label.total_amount") }}:
											</th>
											<th>
												{{ order.total | currency }}
											</th>
										</tr>
									</thead>
								</v-simple-table>
							</div>
							<div class="mt-5">
								<v-btn color="purple" @click="accept(order)" block dark>{{ $t("label.accept_order") }}
								</v-btn>
							</div>
						</v-flex>
					</v-layout>
				</v-card-text>
				<v-divider></v-divider>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialog" persistent max-width="1200px" scrollable>
			<v-form>
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.products") }}
						<v-spacer></v-spacer>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap class="py-2 px-2">
							<v-flex xs12 md12>
								<v-card>
									<v-card-text>
										<v-simple-table>
											<template v-slot:default>
												<thead>
													<tr>
														<th class="text-left">
															<v-checkbox v-model="
																select_all
															" @click="
																select()
															"></v-checkbox>
														</th>
														<th class="text-left">
															{{
															$t("label.item")
															}}
														</th>
														<th class="text-left">
															{{
															$t(
															"label.if_not_available"
															)
															}}
														</th>
														<th class="text-left">
															{{
															$t(
															"label.quantity"
															)
															}}
														</th>
														<th class="text-left">
															{{ $t("Price") }}
														</th>
														<th class="text-left">
															{{
															$t(
															"label.subtotal"
															)
															}}
														</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(
															line, index
														) in order.items" :key="index">
														<td>
															<v-checkbox v-model="
																selected
															" :value="
																line.product_id
															"></v-checkbox>
														</td>
														<td>
															<a :href="
																$route(
																	'tenant.products.show',
																	{
																		tenant: $page
																			.props
																			.tenant
																			.id,
																		product:
																			line.product_uuid,
																	}
																)
															" target="_blank">
																{{
																line.product_name
																}}
																<v-icon right small>mdi-open-in-new</v-icon>
															</a>
															<p v-if="line.note">
																<code class="
																		red
																		lighten-4
																		text-caption
																	">
																	{{
																		line.note
																	}}
																</code>
															</p>
														</td>
														<td>
															<v-chip small v-if="
																line.unavailable ==
																'remove_item'
															" color="warning" outlined>
																<v-icon left>
																	mdi-minus
																</v-icon>
																{{
																line.unavailable
																}}
															</v-chip>
															<v-chip small v-if="
																line.unavailable ==
																'cancel_order'
															" color="error" outlined>
																<v-icon left>
																	mdi-cancel
																</v-icon>
																{{
																line.unavailable
																}}
															</v-chip>
															<v-chip small v-if="
																line.unavailable ==
																'call_me'
															" color="primary" outlined>
																<v-icon left>
																	mdi-phone
																</v-icon>
																{{
																line.unavailable
																}}
															</v-chip>
														</td>
														<td>
															{{ line.quantity }}
														</td>
														<td>
															{{
															line.price
															| currency
															}}
														</td>
														<td>
															{{
															(line.quantity *
															line.price)
															| currency
															}}
														</td>
													</tr>
												</tbody>
												<tfoot>
													<tr>
														<td colspan="4">
															&nbsp;
														</td>
														<td class="text-right">
															<strong>
																{{
																$t(
																"label.total"
																)
																}}</strong>
														</td>
														<td>
															<strong>{{
															order.total
															| currency
															}}</strong>
														</td>
													</tr>
												</tfoot>
											</template>
										</v-simple-table>
									</v-card-text>
								</v-card>
							</v-flex>
							<v-flex xs12 md12 class="mt-5">
								<v-card>
									<v-card-title>{{ $t("title.delivery_duration") }}
									</v-card-title>
									<v-divider></v-divider>
									<v-card-text>
										<v-chip-group v-model="item.delivery_duration"
											active-class="blue--text text--accent-4" mandatory>
											<v-chip value="5">
												<v-icon left v-if="
													item.delivery_duration ==
													'5'
												" dark color="blue">mdi-check</v-icon>
												<span class="hidden-sm-and-down">{{
												$t("label.5_min")
												}}</span>
											</v-chip>

											<v-chip value="10">
												<v-icon left v-if="
													item.delivery_duration ==
													'10'
												" dark color="blue">mdi-check</v-icon>
												<span class="hidden-sm-and-down">{{
												$t("label.10_min")
												}}</span>
											</v-chip>
											<v-chip value="15">
												<v-icon left v-if="
													item.delivery_duration ==
													'15'
												" dark color="blue">mdi-check</v-icon>
												<span class="hidden-sm-and-down">{{
												$t("label.15_min")
												}}</span>
											</v-chip>
											<v-chip value="20">
												<v-icon left v-if="
													item.delivery_duration ==
													'20'
												" dark color="blue">mdi-check</v-icon>
												<span class="hidden-sm-and-down">{{
												$t("label.20_min")
												}}</span>
											</v-chip>
											<v-chip value="25">
												<v-icon left v-if="
													item.delivery_duration ==
													'25'
												" dark color="blue">mdi-check</v-icon>
												<span class="hidden-sm-and-down">{{
												$t("label.25_min")
												}}</span>
											</v-chip>
											<v-chip value="30">
												<v-icon left v-if="
													item.delivery_duration ==
													'30'
												" dark color="blue">mdi-check</v-icon>
												<span class="hidden-sm-and-down">{{
												$t("label.30_min")
												}}</span>
											</v-chip>
										</v-chip-group>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="info" text @click="closeItem()">
							<v-icon left>mdi-arrow-left</v-icon>{{ $t("Close") }}
						</v-btn>
						<v-btn color="primary" :disabled="!correct" @click.native="submit(order)"
							:loading="item.processing">
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("label.accept") }}
						</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
		<v-dialog v-model="dialog_declined" persistent max-width="700px">
			<ValidationObserver ref="obs" v-slot="{ invalid }">
				<v-form>
					<v-card>
						<v-card-title primary-title>
							{{ $t("title.declined_reason") }}
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-container grid-list-md>
								<v-layout row wrap>
									<v-flex xs12>
										<ValidationProvider name="cancel_reason" rules="required"
											v-slot="{ errors, valid }">
											<v-textarea v-model="item.cancel_reason" :label="
												$t('title.declined_reason')
											" :error-messages="errors" :append-icon="
												valid ? 'mdi-check' : null
											"></v-textarea>
										</ValidationProvider>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="info" text @click="closeItemDeclined()">
								<v-icon left>mdi-arrow-left</v-icon>{{ $t("Close") }}
							</v-btn>
							<v-btn color="primary" @click.native="submit_declined(order)" :disabled="invalid">
								<v-icon left>mdi-content-save</v-icon>
								{{ $t("label.declined") }}
							</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-form>
			</ValidationObserver>
		</v-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			item: this.$inertia.form({
				cancel_reason: null,
				delivery_duration: null,
			}),
			reservation: {},
			order: {
				items: [],
			},
			dialog: false,
			selected: [],
			select_all: false,
			dialog_declined: false,
		};
	},
	computed: {
		correct() {
			if (this.order.items) {
				return this.selected.length == this.order.items.length;
			}

			return false;
		},
	},
	methods: {
		accept(order) {
			this.order = Object.assign({}, order);
			this.dialog = true;
		},

		closeItem() {
			this.order.items = Object.assign({}, {});
			this.dialog = false;
			this.$wait.end("modal order");
		},

		async submit(order) {
			try {
				await this.item.post(
					this.$route("tenant.orders.mark_as_accept", {
						tenant: this.$page.props.tenant.id,
						order: order.uuid,
					}),
					{
						onFinish: () => this.closeItem(),
					}
				);
			} finally {
				this.closeItem();
				this.$wait.end("modal order");
			}
		},

		declined(order) {
			this.order = Object.assign({}, order);
			this.dialog_declined = true;
		},

		closeItemDeclined() {
			this.dialog_declined = false;
		},

		async submit_declined(order) {
			try {
				this.item.post(
					this.$route("tenant.orders.mark_as_declined", {
						tenant: this.$page.props.tenant.id,
						order: order.uuid,
					})
				);
			} finally {
				this.$wait.end("modal order");
				this.closeItemDeclined();
			}
		},

		async confirmed(reservation) {
			try {
				await this.$inertia.post(
					this.$route("tenant.reservations.mark_as_confirmed", {
						tenant: this.$page.props.tenant.id,
						reservation: reservation.uuid,
					})
				);
			} finally {
				this.$wait.end("modal reservation");
			}
		},

		async denied_reservation(reservation) {
			try {
				await this.$inertia.post(
					this.$route("tenant.reservations.mark_as_denied", {
						tenant: this.$page.props.tenant.id,
						reservation: reservation.uuid,
					})
				);
			} catch (error) {
				this.$toast.error(error.message);
			} finally {
				this.$wait.end("modal reservation");
			}
		},

		select() {
			this.selected = [];
			if (this.select_all) {
				for (let i in this.order.items) {
					this.selected.push(this.order.items[i].product_id);
				}
			}
		},
	},
	created() {
		window.Echo.private(
			`App.Models.User.${this.$page.props.auth.user.id}`
		).notification((notification) => {
			this.$page.props.auth.unreadNotificationsCount++;
			switch (notification.type) {
				case "reservation.confirmed":
					this.$wait.start("modal reservation");
					this.reservation = Object.assign({}, notification.data);
					break;
				case "order.pending":
					this.$wait.start("modal order");
					this.order = Object.assign({}, notification.order);
					break;
				case "order.accepted":
					this.$wait.end("modal order");
				case "order.declined":
					this.$wait.end("modal order");
				case "admin.driver.accepted":
					this.$toast.open("Driver accpeted the order");
					break;
				case "admin.driver.refused":
					this.$toast.error("Driver refused the order");
					break;
				default:
					break;
			}
		});
	},
};
</script>